export const constructFullRedirectUrl = (
  baseRedirectUrl: string,
  pageRedirectIndicator: string = "from",
): string => {
  const searchParams = new URLSearchParams(window.location.search)

  // We are getting a "from" value of URL to know which page we need
  // to redirect the user after redeeming the code
  const fromUrl = searchParams.get(pageRedirectIndicator)

  // If there is not "from" value in search params we redirect
  // to base url
  if (!fromUrl) return baseRedirectUrl

  // All additional params are joined together and transformed
  // to get a full context of what page state we should show
  // (f.e. what tab based on the URL)
  const additionalParams = [...searchParams.entries()]
    .filter((item) => item[0] !== pageRedirectIndicator)
    .map((item) => item.join("="))
    .join("&")

  // Constructing full URL with search params to redirect
  // to correct context
  const fullUrl = `${fromUrl}?${additionalParams}`

  // To avoid adding unnecesary "?" sign at the end of URL,
  // we are checking if there are any additional params
  const toUrl = additionalParams.length ? fullUrl : fromUrl

  return fromUrl ? toUrl : baseRedirectUrl
}

export const constructUrlWithSearchParams = (baseUrl: string): string => {
  const urlSearchParams = new URLSearchParams(window.location.search)

  // We map over all search URL to construct new search params
  const searchParams = [...urlSearchParams]
    .map((item) => item.join("="))
    .join("&")

  // If we have a search params string we join it with the base URL
  return searchParams.length ? `${baseUrl}?${searchParams}` : baseUrl
}

export const isExternalUrl = (item: string) => item.startsWith("http")
